import React, { Component } from 'react'
import { connect } from 'react-redux'
import Divider from 'material-ui/Divider'
import dataActions from 'actions/dataActions'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import rightStackActions from 'actions/rightStackActions'
import newCommentActions from 'actions/newCommentActions'
import { dirtyRead, doc, edit, routing, login } from 'selectors/common'
import BillFormLeftSide from './BillForm/LeftSide'
import InvoiceFormLeftSide from './InvoiceForm/LeftSide'
import PaymentFormLeftSide from './PaymentForm/LeftSide'
import BillFormRightSide from './BillForm/RightSide'
import InvoiceFormRightSide from './InvoiceForm/RightSide'
import PaymentFormRightSide from './PaymentForm/RightSide'
import attachmentActions from 'actions/attachmentActions'

import FormHeader from 'components/FormHeader'
import FormFooter from 'components/FormFooter'
import Deleted from 'components/Deleted'
import { invalid } from 'selectors/transactions'

let select = dirtyRead(
	(state, props) => {
		return {
			doc: doc(state, props.id || props.routeParams.id)
  	  	  , invalid: invalid(state, props.id || props.routeParams.id) || false
		}
	}
)

export class Transaction extends Component{
	render(){
			let { props } = this
			let doc = props.doc || {}
			let types = {
				'transaction/bill': {leftSide: BillFormLeftSide, rightSide: BillFormRightSide}
				,'transaction/invoice': {leftSide: InvoiceFormLeftSide , rightSide: BillFormRightSide}
				,'transaction/invoice-payment': {leftSide: PaymentFormLeftSide , rightSide: PaymentFormRightSide}
			}
			let LeftSide = (types[doc.type] || {}).leftSide || null
			let RightSide = (types[doc.type] || {}).rightSide || null
			let transactionID = this.props.id || this.props.routeParams.id
			let colspan = this.props.colspan || 2
			let widthColumns = "100%" //(this.props.style && this.props.width && colspan)?(this.props.width.split('px')[0]/colspan)-18+"px":"50%"
			return (
				<div
					style={{
						display: "inline-block"
					  , width: "100%"
					  , backgroundColor: "#FFF"
					  , overflow: "hidden"
					}}
				>
					<FormHeader
						title={(!this.props.doc
							?"Transaction ":doc.type=='transaction/bill'
							?"Bill "
							:doc.type=='transaction/invoice'
							?"Invoice "
							:"Payment ")
						}
						statusIcon={null/*<div style={{position:"relative", top:"-7px"}}><TransactionStatusIcon transactionID={transactionID} /></div>*/}
						masterDetail={this.props.masterDetail || false}
						objectID= {transactionID}
						commitDisabled={!!props.invalid}
					/>
					{(!this.props.doc)?
						<Deleted />
						:
						<div style={{position:"relative", height:"calc(100vh - 64px)", overflowX: "hidden", backgroundColor: "#f3f5f4"}}>
						<main style={{minHeight:"calc(100vh - 64px)", display:(colspan>1)?"flex":"block"}}>
							<LeftSide transactionID={transactionID} colspan={colspan}/>
							{colspan==1 && <Divider style={{marginTop: "0px"}}/>}
							<RightSide transactionID={transactionID} colspan={colspan}/>
						</main>
						{transactionID &&
							<div
								style={{
									position:"fixed"
							      , zIndex:"9999"
								  , bottom:"3px"
								  , right:"17px"
								  , boxSizing: "borderBox"
								  , maringRight: "17px"
								}}
							>
								<FormFooter masterDetail={this.props.masterDetail || false} commitDisabled={!!props.invalid} objectID={transactionID} />
							</div>
						}
						</div>
					}

				</div>
			)
	}
}

export default connect(select)(Transaction)
//export default connect(select, {...dataActions, ...attachmentOverlayActions, ...attachmentActions, ...newCommentActions, ...rightStackActions})(Transaction)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/index.js